import createReactComponent from '../createReactComponent';
export default createReactComponent('zoom-in', 'IconZoomIn', [
  ['path', { d: 'M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0', key: 'svg-0' }],
  ['path', { d: 'M7 10l6 0', key: 'svg-1' }],
  ['path', { d: 'M10 7l0 6', key: 'svg-2' }],
  ['path', { d: 'M21 21l-6 -6', key: 'svg-3' }],
]);
